import { render, staticRenderFns } from "./NewTools.vue?vue&type=template&id=681d993f&scoped=true&"
import script from "./NewTools.vue?vue&type=script&lang=js&"
export * from "./NewTools.vue?vue&type=script&lang=js&"
import style0 from "./NewTools.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NewTools.vue?vue&type=style&index=1&id=681d993f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681d993f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('681d993f')) {
      api.createRecord('681d993f', component.options)
    } else {
      api.reload('681d993f', component.options)
    }
    module.hot.accept("./NewTools.vue?vue&type=template&id=681d993f&scoped=true&", function () {
      api.rerender('681d993f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/pages/NewTools.vue"
export default component.exports